<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{ hsct.eign_naam }} as {{ hsct.hsct_rol }} from the accommodation {{hsct.huis_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHsct">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

// import {bus} from "../../../main";

export default {
  data() { 
    return {
      dialog: false,
      hsct_encrid: null,
      hsct: {}
    }
  },
  methods: {
    open(hsct_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hsct/getHsct.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsct"
          },
          getHsct: {
            hsct_encrid: hsct_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsct = res.data.getHsct;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHsct() { 
      this.$axios
        .post("ares/json/ares/huis/hsct/rmHsct.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHsct"
          },
          rmHsct: {
            hsct_encrid: this.hsct.hsct_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             // if (res.data.rmHsct.color == "success") { 
                //setTimeout(() => { this.$router.reload('/huis/onHuis/' + res.data.rmHsct.huis_encrid);  }, 2000);      
                // bus.$emit("closeDialog", "reload");
             // }   
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHsct.text,
              color: res.data.rmHsct.color
            });
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    },
  }
}
</script>

